<template>
<div class="page-container-wrapper">
  <loader v-if="dataLoading"/>
  <template v-else>
    <div class="page-container-header d-flex align-items-center">
        <h2 class="text-md mb-0">{{ $t('message.Guideline.publications') }}</h2>

        <b-button variant="info" class="mr-2 ml-auto" @click="goBack">{{ $t('message.return') }}</b-button>
    </div>

    <div class="container-fluid">
      <div class="row">
        <!-- LEFT -->
        <div class="col-md-12 col-xl-7">
          <div class="page-container guidelines-editor" id="page-container">
            <b-alert v-show="dataError" class="mt-4" show variant="danger">{{ $t('message.connectionError') }}</b-alert>
            <div class="px-4">
              <div class="row">
                <div class="col-md-12">
                  <!-- LEFT BASE DATA -->
                  <base-data-left :guideline="guideline" class="d-xl-none"></base-data-left>

                  <!-- LEFT PROGRESS -->
                  <phase-preview-left :guideline="guideline" class="d-xl-none"></phase-preview-left>
asd
                  <b-card :title="$t('message.Guideline.sectionUploadedFiles')" class="mb-2 fileUploader">
                    <template v-if="filesUploaded && filesUploaded.length">
                      <b-table striped hover :items="filesUploaded" :fields="['size', {key: 'upload_id', label: $t('message.Guideline.uploadId')}, {key: 'name', label: $t('message.Guideline.file')}, 'type', 'actions']">
                        <template slot="info" slot-scope="data">
                          <pre>
                            {{ data.item.response.data.id  }}
                          </pre>
                        </template>

                        <template slot="upload_id" slot-scope="data">
                          {{ $t("message.Guideline.fileVersion", {version: data.item.upload_id}) }}
                        </template>

                        <template slot="progress" slot-scope="data">
                          <b-progress :value="parseInt(data.item.progress)" :max="100" show-progress animated></b-progress>
                        </template>

                        <template slot="actions" slot-scope="data">
                          <a target="_blank" :href="data.item.url">
                            <font-awesome-icon icon="download" size="lg" class="mr-2"/>
                          </a>

                          <a v-if="isSuperUser" @click.prevent="deleteFileInfo(data.item)">
                            <font-awesome-icon icon="trash" size="lg" class="mr-2 text-danger"/>
                          </a>
                        </template>
                      </b-table>
                    </template>

                    <button class="btn btn-outline-secondary" @click="prepareZippedFiles(guideline.submitter_id, '')">
                      {{ $t('message.Guideline.downloadZipped') }}
                    </button >

                    <button  v-if="isSuperUser" class="btn btn-outline-primary ml-2" @click="uploadForUser(guideline.submitter_id, guideline.upload_id)">
                      <template v-if="isSuperUser">
                        {{ $t('message.Guideline.uploadForUser') }}
                      </template>
                      <template v-else>
                        {{ $t('message.Guideline.upload') }}
                      </template>
                    </button >
                  </b-card>

                  <b-card v-if="guideline.id != null && (isGpc)" :title="$t('message.Comments.title')" class="mb-2">
                    <comments :guidelineId="guideline.id" :locked="false" :onHold=true></comments>
                  </b-card>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- RIGHT -->
        <div class="d-md-none d-xl-block col-xl-5">
          <base-data-right :guideline="guideline"></base-data-right>

          <phase-preview :guideline="guideline"></phase-preview>
        </div>
      </div>
    </div>


  </template>
</div>
</template>

<script>
import { 
  GUIDELINE_REQUEST_BY_ID,
  GUIDELINE_DELETE_FILE_BY_ID 
} from '@/store/actions/guidelines'

import { Guideline, GuidelinePhases } from '@/lib/guideline.js'

import Api from '@/services/Api';

import Comments from '@/components/Comments'

import BaseDataRight from '@/components/Guideline/BaseData/right.vue'
import BaseDataLeft from '@/components/Guideline/BaseData/left.vue'

import PhasePreview from '@/components/Guideline/PhasePreview'
import PhasePreviewLeft from '@/components/Guideline/PhasePreview/left.vue'

export default {
  name: 'guideline-review',
  components: {
    Comments,
    BaseDataRight,
    BaseDataLeft,
    PhasePreview,
    PhasePreviewLeft
  },
  props: [],
  data () {
    return {
      guideline: new Guideline,
      guidelinePhases: GuidelinePhases,

      files: [],
      filesCount: 0,
      changeType: null,
      comment: null,
      showAdminUpload: false,
      adminUpload: {
        userId: null,
        uploadId: null,
        show: false
      },
    }
  },
  computed: {
    filesUploaded() {
      if (this.guideline && this.guideline.files) {
        return this.guideline.files.filter(elem => { return elem.upload_id != null && elem.user_id == this.guideline.submitter_id; });
      }

      return [];
    },
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData() {
      this.$store.dispatch(GUIDELINE_REQUEST_BY_ID, this.$route.params.id).then((response) => {
        if (response.data.data.phase <  this.guidelinePhases.uploadedForReview) {
           this.$router.push('/guidelines/' + response.data.data.id + '/view')
        }

        this.guideline = response.data.data;
        
        this.files = this.guideline.files.filter(elem => (elem.user_id == this.getUserData.id && elem.upload_id == null));

      }).catch((error) => {
        this.handleUnauth(error.response.status);
      });
    },

    goBack() {
      this.$router.push('/guidelines/')
    },

    getZipped() {
      window.open(this.guideline.zipUrl);
    },

    deleteFileInfo(file, fileIndex) {
      let fileId = file.response != undefined ? file.response.data.id : file.id;

      this.$swal({
        title: this.$t('message.areYouSure'),
        html: this.$t('message.Guideline.deleteFileInfo'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('message.yesImSure'),
        cancelButtonText: this.$t('message.noCancel'),
      }).then((result) => {
        if (result.value != undefined) {
          this.deleteFile(fileId, fileIndex);
        }
      });
    },

    deleteFile(fileId) {
      this.$store.dispatch(GUIDELINE_DELETE_FILE_BY_ID, {gid: this.guideline.id, fid: fileId})
      .then(() => {
        this.getData();
      }).catch((error) => {
        this.handleUnauth(error.response.status);
      });
    },
    
    prepareZippedFiles(userId, uploadId) {
      /**
       * Set as downloaded for user
       */
      let files = this.guideline.files.filter(row => {return row.user_id == userId && row.upload_id == uploadId})

      for (let x in files) {
        files[x].downloaded = true
      }

      Api().get(`/guidelines/prepare-zipped/${this.guideline.id}/${userId}/${uploadId}`).then( response => {
          window.open(response.data.fileUrl);
        }).catch((error) => {
          this.handleUnauth(error.response.status);
          this.handleForbidden(error.response.status);
        });
    },

    getFileUrl(file) {
      return (file.response && file.response.data != undefined) ? file.response.data.url : (file.url!=undefined?file.url:null);
    },

    setDownloaded(fileId) {
      let file = this.guideline.files.filter(row => row.id == fileId)

      if (file[0] != undefined) {
        file[0].downloaded = true
      }
    },

    getUserFiles(userId, uploadId) {
      return this.guideline.files.filter(elem => {return elem.user_id == userId && elem.upload_id == uploadId});
    },

    addFilesToGuideline() {
      this.showAdminUpload = true;
    },
  }
}
</script>

<style lang="scss">
.guidelines-view {
}

.dragActive{
  background: white;
}

.dropzone {
  background: #e6e6e6;
  text-align: center;
  padding: 30px;
  border: 2px dashed;

  div {
    padding: 20px;
  }
}

.col-form-label {
  text-align: left;
}

.file-uploads {
  overflow: hidden;
  position: relative;
  text-align: center;
  display: inline-block;
}
.file-uploads.file-uploads-html4{
    input[type="file"] {
    opacity: 0;
    font-size: 20em;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: absolute;
    width: 100%;
    height: 100%;
  }
}

.file-uploads.file-uploads-html5{
  input[type="file"] {
    overflow: hidden;
    position: fixed;
    width: 1px;
    height: 1px;
    z-index: -1;
    opacity: 0;
  }
}

.review-details {
  padding: 2rem 0;
  margin-bottom: 2rem;
  //box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border: 1px solid #cccccc;
  border-radius: 4px;
}

.border-with-shadow {
  background-color: #ffffff;
  -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
</style>
